const normalizeScopes = (scopeValue) => {
  if (!scopeValue) {
    return [];
  }

  if (Array.isArray(scopeValue)) {
    return scopeValue
      .map((scope) => (typeof scope === 'string' ? scope.trim() : ''))
      .filter(Boolean);
  }

  if (typeof scopeValue === 'string') {
    return scopeValue
      .split(scopeValue.includes(',') ? ',' : /\s+/)
      .map((scope) => scope.trim())
      .filter(Boolean);
  }

  return [];
};

const scopeQuestionByKeyword = [
  {
    keywords: ['contact', 'subscriber', 'lead'],
    question:
      'Which contact segments are growing or shrinking fastest this week?',
  },
  {
    keywords: ['deal', 'opportunity', 'pipeline', 'sales'],
    question:
      'Which pipeline stages are stalled and where should we focus today?',
  },
  {
    keywords: ['email', 'campaign', 'newsletter'],
    question: 'Which campaigns are driving the most engagement right now?',
  },
  {
    keywords: ['calendar', 'meeting'],
    question: 'What meetings or commitments could block key priorities today?',
  },
  {
    keywords: ['ticket', 'support', 'case'],
    question: 'What support issues are trending and need immediate action?',
  },
  {
    keywords: ['ad', 'ads', 'marketing', 'attribution'],
    question:
      'Where are we spending budget with weak return versus strong return?',
  },
  {
    keywords: ['order', 'commerce', 'shop', 'product'],
    question:
      'What products or orders changed most recently and why does it matter?',
  },
];

const getScopeDrivenQuestions = (scopes) => {
  const questions = [];
  const normalizedScopeString = scopes.join(' ').toLowerCase();

  scopeQuestionByKeyword.forEach(({ keywords, question }) => {
    if (keywords.some((keyword) => normalizedScopeString.includes(keyword))) {
      questions.push(question);
    }
  });

  return questions;
};

const dedupe = (items) => Array.from(new Set(items.filter(Boolean)));

export const buildOperatingPulse = (connectorProfiles) => {
  const safeProfiles = Array.isArray(connectorProfiles)
    ? connectorProfiles
    : [];

  const connectorNames = safeProfiles.map(
    (profile) => profile.label || profile.key || 'Connector'
  );
  const allScopes = dedupe(
    safeProfiles.flatMap((profile) => normalizeScopes(profile.scopes))
  );

  const connectorSpecificQuestions = safeProfiles.map((profile) => {
    const connectorName = profile.label || profile.key || 'this connector';
    return `What changed in ${connectorName} in the last 24 hours that I should care about?`;
  });

  const baseQuestions = [
    'What are the top 3 things I should focus on today?',
    'What changed since yesterday that needs attention?',
  ];

  const scopeDrivenQuestions = getScopeDrivenQuestions(allScopes);

  const questions = dedupe([
    ...baseQuestions,
    ...connectorSpecificQuestions,
    ...scopeDrivenQuestions,
  ]).slice(0, 6);

  return {
    title: 'Operating Pulse',
    connectors: connectorNames,
    scopeCount: allScopes.length,
    generatedAt: new Date().toISOString(),
    questions,
  };
};

export const buildInitialPromptFromPulse = (pulse) => {
  const connectorCount = pulse?.connectors?.length || 0;
  if (!connectorCount) {
    return 'Genesis is ready. Connect at least one data source and I will generate your operating pulse.';
  }

  const topQuestions = Array.isArray(pulse?.questions)
    ? pulse.questions.slice(0, 3)
    : [];
  const list = topQuestions.map((question, i) => `${i + 1}. ${question}`);

  return `Genesis is live with ${connectorCount} connector${
    connectorCount === 1 ? '' : 's'
  }. Here is your operating pulse:\n${list.join('\n')}`;
};
